<template>
	<div class="shop-wrapper" :class="{ 'page-custom': !isDefaultHeaderImageUrl }">

		<!-- #region location1 -->
		<!-- 头部渐变(特殊背景才有) -->
		<div class="header" v-if="!isDefaultHeaderImageUrl" :style="{ height: location1Height + 'px' }"></div>
		<div id="location1" class="location1" :class="{ 'location1-default': isDefaultHeaderImageUrl }"
			:style="{ height: location1Height + 'px' }">
			<div class="location1-l">
				<img v-if="isDefaultLogoUrl" src="https://file.40017.cn/hubble/alliance/mine-logo.png" />
				<img v-if="!isDefaultLogoUrl" :src="logoUrl" />
			</div>
			<div class="location1-r">
				<div class="location1-r-t">
					<div class="location1-name">{{ shopName }}</div>
				</div>
				<div class="location1-r-b">{{ slogan }}</div>
			</div>
		</div>
		<div class="location1-img" :style="{ height: location1Height + 'px' }" v-if="hasCustomBg">
			<img :src="headerImageUrl" alt="">
		</div>
		<div id="searchBox" class="search-box" :class="{ 'search-box-no-location2': !location2.showFlag }" @click="goSearch">
			<div class="search-box-inner">
				<img class="search-icon" src="https://file.40017.cn/hubble/alliance/icon-search.png" alt="">
				<span class="search-placeholder">搜索商品</span>
			</div>
		</div>
		<!-- #endregion location1 -->

		<!-- #region location2 -->
		<div id="location2" class="location2" v-if="location2.showFlag">
			<div class="location2-1">
				<div class="location2-1-l">爆款推荐</div>
			</div>
			<div class="location2-2">
				<!-- 加载中 -->
				<div v-if="recommendProductsLoading" class="location2-pitem" v-for="(item, index) in [1, 2, 3, 4]"
					:key="index">
					<div class="pitem-img skeleton--animate">
						<div style="width:100%" class="skeleton__row2"></div>
					</div>
					<div class="pitem-info skeleton--animate">
						<div style="width:100%" class="skeleton__row3"></div>
						<div style="width:100%" class="skeleton__row4"></div>
						<div style="width:100%" class="skeleton__row5"></div>
					</div>
				</div>

				<!-- 加载完毕 -->
				<div v-if="!recommendProductsLoading" @click="goProduct(item)" v-for="(item, index) in recommendProducts" :key="index"
					class="location2-pitem">
					<div class="pitem-img">
						<div class="img-cover-1">{{ formateCategory(item) }}</div>
						<div class="img-cover" v-if="item.cityName">
							<div class="img-cover-2">
								<img mode="aspectFill" src="https://file.40017.cn/hubble/alliance/icon-address.png"
									class="icon-address" />
								{{ formateCity(item.cityName) }}
							</div>
						</div>
						<!-- 产品图片 -->
						<div class="pitem-img-product">
							<img :src="item.headPicture" />
						</div>
					</div>
					<div class="pitem-info">
						<div class="pitem-title">{{ item.firstItem }}</div>
						<div class="pitem-bottom">
							<div class="pitem-price">
								<div class="pitem-price-l">
									<span class="pitem-price-l-unit">￥</span><span class="price-txt">{{ item.price }}</span>
									<span class="price-qi">起</span>
								</div>
								<div class="pitem-price-r" v-if="item.commentScore">
									<span class="price-score">{{ item.commentScore }}</span>
									<span class="price-fen">分</span>
								</div>
							</div>
							<div class="pitem-btn">
								<div class="sell-order">点击预订</div>
							</div>
						</div>
					</div>
					<!-- 出行 -->

					<!-- 活动 -->
				</div>

				<!-- 加载完毕但是没有数据 -->
				<div v-if="!recommendProductsLoading && recommendProducts.length == 0">
					<div class="empty">
						<img src="https://file.40017.cn/hubble/alliance/icon-list-empty.png" alt="">
						<div class="empty-txt">暂无数据</div>
					</div>
				</div>
			</div>
		</div>
		<!-- #endregion location2 -->

		<!-- #region location3 -->
		<div class="location3" :class="{ location3Style2: location2.showFlag ? false : true }">
			<!-- 头部 -->
			<div class="location3-1" id="location31">
				<div class="location3-1-l">掌柜推荐</div>
			</div>
			<!-- 导航 -->
			<!-- 我的信息加载前 -->
			<div v-if="baseInfoLoading" class="location3-menu" :style="{ position: 'sticky', top: searchBoxHeight + 'px', zIndex: 100 }">
				<div class="custom-class skeleton">
					<div class="skeleton__content skeleton--animate"  style="padding-left: 0px">
						<div style="width:100%;height: 0.5rem;" class="skeleton__row"></div>
					</div>
				</div>
			</div>
			<!-- 我的信息加载后 -->
			<div v-if="!baseInfoLoading" class="location3-menu" :style="{ position: 'sticky', top: searchBoxHeight + 'px', zIndex: 100 }">
				<div v-for="(item, index) in menus" :key="index">
					<div v-if="item.showFlag" class="menu-item"
						:class="{ 'menu-item-active': item.active ? true : false }" @click="handleTab(item)">
						<div class="menu-item-title">{{ item.title }}</div>
					</div>
				</div>
			</div>

			<!-- 骨架屏 -->
			<div v-if="productLoading" class="product-wrapper">
				<div class="custom-class skeleton" v-for="(item, index) in [1, 2, 3, 4, 5]" :key="index">
					<div class="avatar-class skeleton__avatar skeleton__avatar--square skeleton--animate">
					</div>
					<div class="skeleton__content skeleton--animate">
						<div style="width:100%" class="skeleton__row"></div>
						<div style="width:100%" class="skeleton__row"></div>
						<div style="width:100%" class="skeleton__row"></div>
						<div style="width:100%" class="skeleton__row"></div>
						<div style="width:100%" class="skeleton__row"></div>
					</div>
				</div>
			</div>

			<!-- 如果没有爆款推荐，高度继续撑开 -->
			<div v-else :class="{'product-wrapper-hideLocation2':!location2.showFlag,'product-wrapper':true}">
				<!-- 产品列表 -->
				<div v-if="orderItems.length > 0">
					<div class="product-item" @click="goProduct(productItem)" v-for="(productItem, index) in orderItems"
						:key="index">
						<div class="item-wrapper" v-if="isHotel(productItem) || isTicket(productItem) || isVocation(productItem) || isScenery(productItem)">
							<div class="item-l">
								<div class="item-l-img-wrapper">
									<div v-if="!productItem.expire" class="background-image" :style="{
										backgroundImage: `url('${productItem.headPicture}')`, width: '2.1rem',
										height: '2.91rem', backgroundSize: 'cover', backgroundPosition: 'center'
									}"></div>
									<div v-if="productItem.expire" class="background-image" :style="{
										backgroundImage: `url('${validProductBg}')`, width: '2.1rem',
										height: '2.91rem', backgroundSize: 'cover', backgroundPosition: 'center'
									}"></div>
								</div>
								<div class="img-cover-1" v-if="isTicket(productItem) || isHotel(productItem)">{{ formateCategory(productItem) }}</div>
								<div class="img-cover-1" v-if="isVocation(productItem) || isScenery(productItem)">{{ productItem.tag}}</div>
								<div class="img-cover" v-if="isHotel(productItem) || isVocation(productItem) || isScenery(productItem)">
									<div class="img-cover-2" v-if="productItem.cityName">
										<img src="https://file.40017.cn/hubble/alliance/icon-address.png"
											class="icon-address" />
										{{ formateCity(productItem.cityName) }}
									</div>
								</div>
							</div>
							<div class="item-r">
								<div class="item-r-t">
									<div class="item-r-t-l">
										<div class="item-r-title">
											<div class="title">
												<span class="title-text" v-if="productItem.bizType == 13">{{ productItem.secondItem }}</span>
												<!-- 度假增加icon -->
												<img v-if="isVocation(productItem) && productItem.diamondLevel" class="vocation-level" :src="`https://file.40017.cn/hubble/alliance/icon1-zuanshi${productItem.diamondLevel}.png`" alt="">
												
												<span class="title-text" v-if="productItem.bizType != 13">{{ productItem.firstItem }}</span>
												<div class="title-tag" v-if="productItem.tag == '豪华型'">
													{{ productItem.tag }}</div>
												<div class="title-tag title-tag-scenery" v-if="isScenery(productItem) && productItem.diamondLevel && productItem.diamondLevel!=0">
												{{productItem.diamondLevel}}A</div>
											</div>
										</div>
										<!-- 票务时间 -->
										<div class="item-r-subtitle-tickettime" style="padding-top:0.04rem;" v-if="isTicket(productItem)">{{productItem.showDate}}</div>
										<!-- 票务地点 -->
										<div class="item-r-subtitle" style="padding-top:0.04rem;" v-if="isTicket(productItem)">{{productItem.venue_name}}</div>
										<div v-if="productItem.skuId && productItem.bizType!=13" class="item-r-subtitle">{{ productItem.skuName }}</div>
										<div v-if="productItem.skuId && productItem.bizType==13" class="item-r-subtitle item-r-subtitle-preorder">{{ productItem.extraPreorderInfo }}</div>
										<div v-if="!productItem.skuId && (isTicket(productItem) || isHotel(productItem) || isScenery(productItem))" class="item-r-subtitle">{{ productItem.secondItem }}</div>
										

										<div class="item-r-comment" v-if="(isHotel(productItem) || isScenery(productItem)) && productItem.commentScore">
											<div class="score" v-if="productItem.commentScore">{{ productItem.commentScore }}分</div>
											<div class="comment-count" v-if="productItem.commentCount">{{ productItem.commentCount }}条点评</div>
										</div>
										<div class="item-r-comment vocation-item-r-comment" v-if="isVocation(productItem) && productItem.commentScore">
											<div class="score" v-if="productItem.commentScore">{{ productItem.commentScore }}<span>%满意度</span></div>
											<div class="comment-count" v-if="productItem.secondItem">{{ productItem.secondItem }}</div>
										</div>
										<div class="item-r-tags" v-if="productItem.tags && productItem.tags.length >0">
											<div class="tag-item" v-for="(item, index) in productItem.tags"
												:key="index">
												{{ item }}
											</div>
										</div>
									</div>
								</div>
								<div class="item-r-m">
									<div class="sell-count">已售{{ productItem.historicalConsumer?productItem.historicalConsumer:0 }}份</div>
								</div>
								<div class="item-r-b">
									<div class="item-r-price" v-if="isTicket(productItem)">
										<div class="price"><span
												class="price-unit">¥</span>{{ productItem.price }}{{ productItem.max_price != productItem.price ? '-' + productItem.max_price : '' }}
										</div>
									</div>

									<div class="item-r-price" v-if="isHotel(productItem) || isVocation(productItem) || isScenery(productItem)">
										<div class="price"
											v-if="(productItem.price && productItem.price != 0)">
											<span class="price-unit">¥</span>{{ productItem.price }}
											<span class="price-qi">起</span>
										</div>
										<div class="price" v-else><span class="price-unit">暂无报价</span></div>
									</div>
									<div class="item-r-sold" v-if="!productItem.expire">
										<div class="sell-order">点击预订</div>
									</div>
									<div class="item-r-sold item-r-sold-offline" v-if="productItem.expire">
										<div class="sell-order">已下架</div>
									</div>
								</div>

							</div>
						</div>

						<!-- 出行 -->
						<div class="item-wrapper" v-if="isPlaneOrTrain(productItem)">
							<div class="item-l item-l-train">
								<div class="item-l-img-wrapper">
									<div v-if="!productItem.expire" class="background-image" :style="{
										backgroundImage: `url('${productItem.headPicture}')`, width: '2.1rem',
										height: '2.1rem', backgroundSize: 'cover', backgroundPosition: 'center'
									}"></div>
									<div v-if="productItem.expire" class="background-image" :style="{
										backgroundImage: `url('${validProductBg}')`, width: '2.1rem',
										height: '2.1rem', backgroundSize: 'cover', backgroundPosition: 'center'
									}"></div>
								</div>
							</div>
							<div class="item-r">
								<div class="item-r-t">
									<div class="item-r-t-l">
										<div class="item-r-title">
											<div class="title">
												<span class="title-text">{{ productItem.firstItem }}</span>
											</div>
										</div>
										<div class="item-r-subtitle item-r-subtitle-train">{{ productItem.secondItem }}</div>
									</div>

								</div>
								<div class="item-r-b">
									<div class="item-r-price">
									</div>
									<div class="item-r-sold" v-if="!productItem.expire">
										<div class="sell-order">点击预订</div>
									</div>
									<div class="item-r-sold item-r-sold-offline" v-if="productItem.expire">
										<div class="sell-order">已下架</div>
									</div>
								</div>
							</div>
						</div>

						<!-- 活动 -->
						<div class="item-wrapper" v-if="isActivity(productItem)">
							<div class="item-l">
								<div class="item-l-img-wrapper">
									<div v-if="!productItem.expire" class="background-image" :style="{
										backgroundImage: `url('${productItem.pictureUrl}')`, width: '2.1rem',
										height: '2.91rem', backgroundSize: 'cover', backgroundPosition: 'center'
									}"></div>
									<div v-if="productItem.expire" class="background-image" :style="{
										backgroundImage: `url('${validProductBg}')`, width: '2.1rem',
										height: '2.91rem', backgroundSize: 'cover', backgroundPosition: 'center'
									}"></div>
								</div>
							</div>
							<div class="item-r">
								<div class="item-r-t">
									<div class="item-r-t-l">
										<div class="item-r-title">
											<div class="title">
												<span class="title-text">{{ productItem.activityName }}</span>
											</div>
										</div>
										<div class="item-r-subtitle item-r-subtitle-activity">{{
		productItem.shareContext }}</div>
									</div>
								</div>
								<div class="item-r-b">
									<div class="item-r-price">
										<div class="price item-r-b-date">有效期至{{ formateDate(productItem.endTime) }}</div>
									</div>
									<div class="item-r-sold" v-if="!productItem.expire">
										<div class="sell-order">点击预订</div>
									</div>
									<div class="item-r-sold item-r-sold-offline" v-if="productItem.expire">
										<div class="sell-order">已下架</div>
									</div>
								</div>

							</div>
						</div>

					</div>
				</div>
				<!-- 产品加载底部 -->
				<div class="empty">
					<img v-if="bottomTxt.img" :src="bottomTxt.img" mode="aspectFill" />
					<div class="empty-txt">{{ bottomTxt.txt }}</div>
				</div>
			</div>
		</div>
		<!-- #endregion location3 -->
	</div>
</template>

<script>
import scroller from "../components/scroller/components/Scroller.vue";
import { debounce, scrollFn, throttle } from "../util/cps/tools"
import { getShopList, getShopInfo, getShopRec, getTags } from "../util/cps/models"
import { SEARCH_SHOP_URL } from "../util/cps/config"
const ProductType = {
	DomesticHotel: 10, //国内酒店
	InternationalHotel: 30, //国际酒店
	Ticket: 40, //票务
	InternationalPlane: 50, //出行国际机票
	DomesticPlane: 60, //出行国内机票
	Train: 70, //出行火车票
	Activity: 999, //活动专题
	Vocation: 90, //度假
	Scenery: 120, //门票
	Bus: 130, //汽车票
	RentCar: 140, //租车
}
const HotelTypeEnumArr = {
	10: "全日房",
	11: "酒店套餐",
	12: "钟点房",
	13: "预售房"
}
const TicketCategoryTypeStr = {
	1: '演唱会',
	2: '体育赛事',
	3: '戏曲艺术',
	4: '话剧歌剧',
	5: '舞蹈芭蕾',
	6: '音乐会',
	7: '亲子演出',
	9: '休闲展览',
	10: '音乐节',
	12: '电竞赛事',
	14: '游戏剧场',
	15: '脱口秀',
	16: '相声',
	17: 'Livehouse'
}
const PAGEINDEX = 1
let requestdata = {
	productType: "",
	page: 1,
	pageSize: 10,
	visitType: 1,
	shopId: ""
};
let bottomTxtEnum = {
	loading: {
		txt: "正在游入中...", img: ""
	},
	end: {
		txt: "没有更多数据了", img: ""
	},
	error: {
		txt: "服务器出差了，请稍后再试~", img: "https://file.40017.cn/hubble/alliance/icon-list-empty.png"
	},
	empty: {
		txt: "暂无数据", img: "https://file.40017.cn/hubble/alliance/icon-list-empty.png"
	}
}
//切换tab加锁
let TABLOCK = false
export default {
	name: "cpsShop",
	components: {
		scroller
	},
	data() {
		return {
			validProductBg:"https://file.40017.cn/hubble/alliance/icon-offline2.png",
			//#region 元素的样式
			docheight: document.documentElement.clientHeight,
			location1Height: document.documentElement.clientHeight * 0.16,
			location2Height: document.documentElement.clientHeight * 0.35,
			scrollHeight: document.documentElement.clientHeight + "",
			//#endregion
			orderItems: [],
			productLoading: true,
			baseInfoLoading: true,
			headerImageUrl: "",
			logoUrl: "",
			isDefaultLogoUrl: true,
			isDefaultHeaderImageUrl: true,
			//背景是否默认
			hasCustomBg: true,
			customPageBg: "https://file.40017.cn/hubble/alliance/detaildemo1.jpg",
			pageBg: "https://file.40017.cn/hubble/alliance/top-bg.png",
			recommendProducts: [],
			recommendProductsLoading: true,
			location2: {
				showFlag: true,
				productType: 0
			},
			menus: [
				{ title: "全部", productType: "", active: true, showFlag: true, },
				{ title: "酒店", productType: 10, active: false, showFlag: true, },
				{ title: "国际酒店", productType: 30, active: false, showFlag: true, },
				{ title: "活动", productType: 999, active: false, showFlag: true, },
				{ title: "出行产品", productType: 60, active: false, showFlag: true, },
				{ title: "演出赛事", productType: 40, active: false, showFlag: true, },
				{ title: "旅游度假", productType: 90, active: false, showFlag: true, },
				{ title: "门票", productType: 120, active: false, showFlag: true, },
			],
			bottomTxt: bottomTxtEnum.loading,
			shopName: "我的店铺",
			slogan: "同程捡漏季节，优惠连连。组团出行超值之旅！同程捡漏季节，优惠连连。组团出行，超值之旅！",
			stickyHeight:0,
			searchBoxHeight: 0
		};
	},
	async mounted() {
		document.title = "我的店铺";
		//请求完模块显示接口后再算下
		this.calStickyHeight()
		this.shopId = this.$route.query.shopId
		requestdata.shopId = this.shopId
		window.onscroll = debounce(this.scrollbottom, 200);
		//获取token？从哪里获取呢？token过期呢？
		window.localStorage.setItem('cpstoken', "")
		this.productLoading = true
		this.baseInfoLoading = true
		this.bottomTxt = bottomTxtEnum.loading
		try {
			//获取我的店铺+爆款信息
			await this.initBaseInfo()
			//获取列表信息
			await this.getData();
			//可能不满足一屏的数据，手动滚动
			if(this.orderItems.length < requestdata.pageSize) {
				await this.getData();
			}
		} catch (error) {
			this.bottomTxt = bottomTxtEnum.error
			this.productLoading = false
			this.baseInfoLoading = false
		}
		this.productLoading = false
		this.baseInfoLoading = false
		
	},
	watch: {},
	methods: {
		//滚动到底部事件
		scrollbottom() {
			//有可能触发两次
			scrollFn(this.getData, 50)
		},
		async initBaseInfo() {
			//1.获取标签
			let res0 = await getTags()
			let tags = res0.datas
			let tagId = 23
			if (!tags || tags.length == 0) {
				return
			}
			let speTags = tags.filter((item) => item.name == '限时高佣')
			if (speTags && speTags.length > 0) {
				tagId = speTags[0].id
				console.log('限时高佣...', tagId)
			}


			//2.获取我的店铺信息
			let res2 = null
			try {
				res2 = await getShopInfo({
					shopId: this.shopId,
					visitType: 1
				})
			} catch (error) {
				console.log('getShopInfo', error)
			}

			//完成这个才能渲染菜单！
			this.handleLocation2(res2)

			this.calStickyHeight()

			//3.获取推荐信息
			let res1 = null
			try {
				res1 = await getShopRec({
					page: 1, pageSize: 10, tagId,
					shopId: this.shopId,
				})
			} catch (error) {
				console.log('getShopRec', error)
				this.recommendProductsLoading = false
			}
			if (res1 && res1.datas) {
				this.recommendProducts = res1.datas
			}
			this.recommendProductsLoading = false
		},
		//获取最新商铺列表数据
		async getData() {
			//出行只需要加载一页
			if (this.isPlaneOrTrain(requestdata) && requestdata.page >= (PAGEINDEX + 1)) {
				this.bottomTxt = bottomTxtEnum.end
				return
			}

			//每次请求需要加锁，防止并发
			if(TABLOCK) {
				return
			}else{
				TABLOCK = true
			}
			
			let res = null
			try {
				res = await getShopList(requestdata)
			} catch (error) {
				console.log('getShopList', error)
				TABLOCK = false
			}
			TABLOCK = false
			let datas = res && res.datas
			//如果发现目前加载的数据都是过期的，那么多加载一页
			//加载完毕或者没有数据
			if (!datas || (datas && datas.length == 0)) {
				//加载过数据，加载完毕
				if (requestdata.page > PAGEINDEX) {
					this.bottomTxt = bottomTxtEnum.end
					return
				} else {
					//没加载过数据
					this.bottomTxt = bottomTxtEnum.empty
					this.productLoading = false
					return
				}
			}
			//预售房数据增加
			if(datas && datas.length > 0) {
				datas.forEach(productItem=>{
					if(productItem.bizType == 13) {
						let extraPreorderInfo = ""
						if(productItem.xContents && productItem.xContents.length > 0) {
						productItem.xContents.forEach(item => {
							extraPreorderInfo += `${item.xCategory}:${item.xName} | `
						});
						}
						extraPreorderInfo = extraPreorderInfo.trimEnd().replace(/\|$/, '');
						productItem.extraPreorderInfo = extraPreorderInfo
					}
				})
				
			}
			this.orderItems = this.orderItems.concat(datas);
			requestdata.page++;
			// if(this.orderItems.length < 10) {
			// 	//数据少于十条，多加载一页再看
			// 	this.getData()
			// }
		},
		//点击菜单
		async handleTab(item) {
			//加锁就不能切换
			if (TABLOCK) { return }

			//滚动到滑动底部的位置
			console.log('this.stickyHeight', this.stickyHeight)
			window.scrollTo(0,this.stickyHeight)

			this.menus.forEach(ele => {
				if (item.productType == ele.productType) {
					ele.active = true
				} else {
					ele.active = false
				}

			});
			//恢复参数
			this.bottomTxt = bottomTxtEnum.loading
			this.productLoading = true
			this.orderItems = []
			requestdata = {
				productType: item.productType,
				page: 1,
				pageSize: 10,
				visitType: 1,
				shopId: this.shopId
			}
			try {
				//获取列表信息
				await this.getData();
				//可能不满足一屏的数据，手动滚动
				if(this.orderItems.length < requestdata.pageSize) {
					await this.getData();
				}
			} catch (error) {
				this.bottomTxt = bottomTxtEnum.error
				this.productLoading = false
			}
			this.productLoading = false
		},
		handleLocation2(res2) {
			if (res2) {
				console.log('res2', res2)
				let { shopName, slogan, headerImageUrl, logoUrl, showFlags } = res2
				this.shopName = shopName
				this.slogan = slogan
				if (headerImageUrl) {
					this.headerImageUrl = headerImageUrl
					this.isDefaultHeaderImageUrl = false
				} else {
					this.headerImageUrl = ""
					this.isDefaultHeaderImageUrl = true
				}
				if (logoUrl) {
					this.logoUrl = logoUrl
					this.isDefaultLogoUrl = false
				}
				console.log('showFlags', showFlags)
				//拆分资源的显示隐藏
				if (showFlags) {
					let menus = this.menus
					//0:false|10:false|30:false|40:false|60:false|999:false
					showFlags.forEach(flagItem => {
						if (flagItem) {
							var { productType, showFlag } = flagItem
							if (productType == this.location2.productType) {
								this.location2.showFlag = showFlag
							} else {
								//其他普通列表是否展示
								menus.forEach(menu => {
									if (menu.productType == productType) {
										menu.showFlag = showFlag
									}
								})
							}
							this.menus = menus
						}
					})
					console.log('menus=>', this.menus)
					console.log('location2=>', this.location2)
				}
			}
		},
		isTicket: function (productItem) {
			if (productItem) {
				if (productItem.productType == ProductType.Ticket) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		isPlaneOrTrain: function (productItem) {
			if (productItem) {
				if (productItem.productType == ProductType.Train
					|| productItem.productType == ProductType.InternationalPlane
					|| productItem.productType == ProductType.DomesticPlane
					|| productItem.productType == ProductType.Bus
					|| productItem.productType == ProductType.RentCar
				) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		isActivity: function (productItem) {
			if (productItem) {
				if (productItem.productType == ProductType.Activity) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		isHotel: function (productItem) {
			if (productItem) {
				if (productItem.productType == ProductType.DomesticHotel
					|| productItem.productType == ProductType.InternationalHotel) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		isVocation: function (productItem) {
			if (productItem) {
				if ([90,100,110].includes(productItem.productType)) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		isScenery: function (productItem) {
			if (productItem) {
				if ([120].includes(productItem.productType)) {
					return true
				} else {
					return false
				}
			}
			return false
		},
		formateDate(endTime) {
			endTime = new Date(endTime)
			let newendTime = `${this.padZero(endTime.getFullYear(), 4)}-${this.padZero(endTime.getMonth() + 1, 2)}-${this.padZero(endTime.getDate(), 2)} `
			return newendTime
		},
		padZero(number, length) {
			return number.toString().padStart(length, '0');
		},
		formateCategory(productItem) {
			let holterTypeStr = ""
			if (productItem.bizType) {
				holterTypeStr = HotelTypeEnumArr[productItem.bizType]
				holterTypeStr = `酒店.${holterTypeStr}`
			}
			if (productItem.categoryId) {
				holterTypeStr = TicketCategoryTypeStr[parseInt(productItem.categoryId)]
			}
			return holterTypeStr
		},
		formateCity(cityName) {
			if (cityName && cityName.length > 7) {
				return cityName.substring(0, 7);
			} else {
				return cityName;
			}
		},
		//加入防抖
		goProduct: throttle(function(productItem){
			//防止多次点击
			let pathurl = ""
			//活动类型单独判断跳转
			if(productItem.productType == ProductType.Activity) {
				pathurl = productItem.clickJumpUrl
				if(productItem.jumpType == 1) {
					//单纯H5就需要拼接webview跳转
					if(pathurl){
						pathurl = `/page/home/webview/webview?src=${pathurl}`
					}else{
						alert("H5链接无法跳转")
					}
					return
				}
				//jumpType = 2,3 小程序和两者都有?
				if(!pathurl) {
					alert("暂无跳转地址")
					return
				}
			}else{
				pathurl = productItem.jumpH5Url
				if(!pathurl){
					alert("暂无链接，请稍后再试")
					return
				}
			}


			//前面需要加斜杠
			if(pathurl[0] != "/"){
				pathurl = "/" + pathurl
			}
			
			// alert(pathurl)
			console.log('pathurl=>', pathurl)
			//最终跳转地址
			wx.miniProgram.navigateTo({
				url: pathurl,
				success: function() {
					console.log("success");
				},
				fail: function(err) {
					console.log(
						"跳转回小程序的页面fail",
						err
					);
				}
			});
		}, 1000),
		goSearch() {
			const url = `${SEARCH_SHOP_URL}?shopId=${this.shopId || ''}`
			if (typeof wx !== 'undefined' && wx.miniProgram && wx.miniProgram.navigateTo) {
				wx.miniProgram.navigateTo({
					url: `/page/home/webview/webview?src=${encodeURIComponent(url)}`,
					success: function() {
						console.log("goSearch success");
					},
					fail: function(err) {
						console.log("goSearch fail", err);
						window.location.href = url;
					}
				});
			} else {
				window.location.href = url;
			}
		},
		calStickyHeight(){
			//计算stickyHeight
			var location1Dom = document.getElementById("location1");
			var searchBoxDom = document.getElementById("searchBox");
			var location2Dom = document.getElementById("location2");
			var location3Dom = document.getElementById("location31");
			var l1height = location1Dom.offsetHeight;
			var searchHeight = searchBoxDom ? searchBoxDom.offsetHeight : 0;
			var l2height = location2Dom ? location2Dom.offsetHeight : 0;
			var l3height = location3Dom.offsetHeight;
			if(!this.location2.showFlag) {
				l2height = 0
			}
			this.searchBoxHeight = searchHeight
			this.stickyHeight = l1height + searchHeight + l2height + l3height
		}
	}
};
</script>
<style scoped>
.shop-wrapper {
	text-align: left;
	font-size: 0.24rem;
	width: 100%;
}

/* #region location1 */
.location1 {
	padding-bottom: 40rpx;
	display: flex;
	flex-direction: row;
	align-items: center;
	position: relative;
}

.location1-default {
	background: url(https://file.40017.cn/hubble/alliance/top-bg.png) no-repeat;
}

.location1-img {
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	overflow: hidden;
}

.location1-img img {
	width: 100%;
}

.location1-l {
	margin-left: 0.3rem;
	width: 1rem;
	height: 1rem;
	border-radius: 0.5rem;
	overflow: hidden;
	border: 1px solid #fff;
}

.location1-l img {
	width: 1rem;
	height: 1rem;
}

.location1-r {
	padding-left: 0.2rem;
	flex: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-right: 0.2rem;
}

.location1-name {
	padding-right: 20rpx;
	font-size: 0.3rem;
	font-weight: bold;
	color: #292b6c;
}

.location1-r-b {
	font-size: 0.26rem;
	color: #888;
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	display: -webkit-box !important;
	-webkit-line-clamp: 2 !important;
	-webkit-box-orient: vertical !important;
	padding-top: 0.05rem;
}

.page-custom .header {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 200px;
	z-index: 100;
	background: linear-gradient(to bottom,
			rgba(4, 6, 60, 0.2),
			rgba(4, 6, 60, 0.7)) !important;
}

.page-custom .location1 {
	z-index: 100;
	position: relative;
}

.page-custom .location1-name {
	color: #fff !important;
}

.page-custom .location1-r-b {
	color: #ccc !important;
}

.page-custom .pageBg {
	width: 100%;
	height: 400rpx;
	position: absolute;
	top: 0;
	left: 0;
}

.search-box {
	position: sticky;
	top: 0;
	z-index: 1001;
	background-color: #fff;
	margin-top: -0.2rem;
	padding: 0.2rem 0.3rem 0.2rem;
	border-top-left-radius: 0.2rem;
	border-top-right-radius: 0.2rem;
}

.search-box-inner {
	display: flex;
	align-items: center;
	height: 0.64rem;
	background-color: #f5f6f8;
	border-radius: 0.32rem;
	padding: 0 0.24rem;
}

.search-icon {
	width: 0.32rem;
	height: 0.32rem;
	flex-shrink: 0;
}

.search-placeholder {
	margin-left: 0.12rem;
	font-size: 0.26rem;
	color: #999;
}

.search-box-no-location2 {
	padding-bottom: 0;
}

/* #endregion location1 */


/* 骨架屏 */
.skeleton--animate {
	animation: skeleton-blink 1.2s ease-in-out infinite;
}

@keyframes skeleton-blink {
	50% {
		opacity: .4
	}
}

.skeleton__avatar {
	background-color: #eee;
	flex-shrink: 0;
	margin-right: 30rpx;
	width: 0.5rem;
	height: 0.5rem;
}

.skeleton {
	box-sizing: border-box;
	display: flex;
	width: 100%;
	background-color: #fff;
	padding: 0.2rem !important;
	padding-bottom: 0rem !important;
}

.skeleton__avatar+.skeleton__content {
	padding-bottom: 0.1rem;
}

.skeleton__content {
	flex: 1;
	padding-left: 0.2rem;
}

.skeleton__title {
	margin: 0;
}

.skeleton__row,
.skeleton__title {
	background-color: #eee;
	height: 0.3rem;
}

.skeleton__row:not(:first-child) {
	margin-top: 0.2rem;
}

.skeleton__avatar {
	width: 2.1rem !important;
	height: 2.9rem !important;
	border-radius: 0.2rem !important;
	background-color: #eee;
}

.skeleton__title,
.skeleton__row {
	background-color: #eee;
}


.skeleton__row2 {
	background-color: #eee;
	height: 2rem;
	border-top-left-radius: 0.2rem;
	border-top-right-radius: 0.2rem;
}

.skeleton__row3 {
	background-color: #eee;
	height: 0.7rem;
	width: 90% !important;
	margin-left: 5%;
}

.skeleton__row4 {
	background-color: #eee;
	height: 0.5rem;
	width: 90% !important;
	margin-left: 5%;
}

.skeleton__row5 {
	background-color: #eee;
	height: 0.5rem;
	width: 90% !important;
	margin-left: 5%;
	margin-bottom: 0.2rem;
}


/* 骨架屏 */

/* 滑动轮播产品 */
.location2 {
	margin-top: 0;
	z-index: 1000;
	position: relative;
}

.location2-1 {
	background-color: #fff;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	height: 1rem;
}

.location2-1-l {
	padding-left: 0.3rem;
	line-height: 1rem;
	font-size: 0.35rem;
	font-weight: bold;
}

.location2-2 {
	width: 100%;
	display: flex;
	flex-direction: row;
	overflow-x: scroll;
	background: linear-gradient(180deg,
			rgba(255, 255, 255, 1) 0,
			rgba(243, 243, 243, 1) 50%,
			rgba(235, 237, 241, 1) 100%);
}

.location2-2::-webkit-scrollbar {
	/* chrome */
	display: none;
}

.location2-pitem {
	margin-left: 0.2rem;
	width: 3rem;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	border-radius: 0.2rem;
	box-sizing: border-box;
}

.location2-pitem:last-child {
	margin-right: 0.2rem;
}

/* 外部图片容器 */
.location2 .pitem-img {
	width: 2.8rem;
	height: 2rem;
	position: relative;

}

/* 产品图片 */
.location2 .pitem-img-product {
	width: 100%;
	height: 2rem;
	border-top-left-radius: 0.2rem;
	border-top-right-radius: 0.2rem;
	overflow: hidden;
}

.location2 .pitem-img-product img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.location2 .img-cover {
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: flex-end;
	position: absolute;
	bottom: 0;
	right: 0;
	left: 0;
	width: 100%;
	height: 0.4rem;
	color: #fff;
	font-size: 0.24rem;
	padding: 0.1rem 0.15rem;
	box-sizing: border-box;
	border-bottom-left-radius: 0.1rem;
	border-bottom-right-radius: 0.1rem;
	background: linear-gradient(180deg,
			rgba(255, 255, 255, 0) 0,
			rgba(0, 0, 0, 0.2) 25%,
			rgba(0, 0, 0, 0.65) 100%);
}

.location2 .img-cover-1 {
	height: 0.2rem;
	line-height: 0.2rem;
	position: absolute;
	top: 0.1rem;
	left: 0.15rem;
	font-size: 0.2rem;
	color: #fff;
}

.location2 .img-cover-2 {
	font-size: 0.2rem;
	height: 0.24rem;
	display: flex;
	align-items: center;
	text-align: right;

}

.location2 .icon-address {
	padding-right: 0.1rem;
	width: 0.2rem;
	height: 0.2rem;
}

.location2 .pitem-info {
	padding-top: 0.2rem;
	height: 2.4rem;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.location2 .pitem-title {
	padding: 0 0.15rem;
	font-size: 0.28rem;
	font-weight: bold;
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	display: -webkit-box !important;
	-webkit-line-clamp: 2 !important;
	-webkit-box-orient: vertical !important;
}

.location2 .pitem-bottom {
	margin-top: 0.15rem;
}

.location2 .pitem-price {
	padding: 0 0.1rem;
	margin-bottom: 0.15rem;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	font-size: 0.24rem;

}

.location2 .price-rmb {
	font-size: 0.24rem;
	color: #ff5a00;
}

.pitem-price-l {
	color: #ff5a00;
}

.location2 .price-qi {
	font-size: 0.24rem;
	color: #999;
	font-weight: bold;
}

.location2 .price-txt {
	font-size: 0.36rem;
	font-weight: bold;
	color: #ff5a00;
}

.location2 .price-score {
	font-weight: bold;
	font-size: 0.3rem;
}

.location2 .price-fen {
	font-size: 0.24rem;
}

.location2 .pitem-btn {
	width: 76%;
	margin-left: 12%;
	background: linear-gradient(to right, #FF9C05, #FF6D30) !important;
	height: 0.6rem;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	border-radius: 0.35rem;
	margin-bottom: 0.2rem;
	font-size: 0.28rem;
}


/* location3 */
.location3 {
	position: relative;
	z-index: 1000;
	padding-top: 0.2rem;
	background-color: #EBEDF1;
}


/* location2不显示的时候样式 */
.location3Style2 {
	margin-top: 0;
	padding-top: 0;
	background-color: transparent;
}

.location3Style2 .location3-1 {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.location3-1 {
	background-color: #fff;
	border-top-left-radius: 0.2rem;
	border-top-right-radius: 0.2rem;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	height: 0.8rem;
}

.location3-1-l {
	padding-left: 0.3rem;
	line-height: 1rem;
	font-size: 0.35rem;
	font-weight: bold;
}


.location3-menu {
	margin-top: -1px;
	display: flex;
	flex-direction: row;
	height: 0.8rpx;
	color: #888;
	/* margin-left: 0.2rem; */
	white-space: nowrap;
	width: 100%;
	display: flex;
	flex-direction: row;
	overflow-x: scroll;
	background-color: #fff;
}

.location3-menu::-webkit-scrollbar {
	/* chrome */
	display: none;
}

.location3 .menu-item {
	font-size: 0.3rem;
	padding: 0 0.15rem;
	height: 0.8rem;
	display: flex;
	align-items: center;
}

.location3 .menu-item:first-child {
	margin-left: 0.1rem;
}

.location3 .menu-item-title {
	border-bottom: 1px solid #fff;
}

.location3 .menu-item-active .menu-item-title {
	border-bottom: 1px solid #FC8324;
	color: #FC8324;
}

/* #region 产品样式 */
.product-wrapper {
	background-color: #fff;
	padding-bottom: 0.2rem;
	/* min-height:50vh; */
	min-height: 100vh;
}
.product-wrapper-hideLocation2{
	min-height:100vh;
}

.product-item {
	width: 100%;
}

.item-wrapper {
	width: 100%;
	display: flex;
	flex-direction: row;
	padding: 0.2rem;
	box-sizing: border-box;
}

.product-item:first-child {
	padding-top: 0.1rem;
}

.product-item .item-l-img-wrapper {
	width: 2.1rem;
	height: 2.91rem;
	overflow: hidden;
	display: flex;
	border-radius: 0.12rem;
}

/* .product-item .item-l .item-l-img {
	width: 100%;
} */
/* .background-image {
	width: 1.8rem;
	height: 2.4rem;
  background-image: url('https://file.40017.cn/alliance/fd1f200501e9413dae6521c2fcc70671.jpg');
  background-size: cover;
  background-position: center;
} */

.product-item .item-l {
	width: 2.1rem;
	height: 2.91rem;
	position: relative;
}

.product-item .item-l-train {
	width: 2.1rem !important;
	height: 2.1rem !important;
	position: relative;
}

.product-item .img-cover {
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: flex-end;
	position: absolute;
	bottom: 0;
	right: 0;
	left: 0;
	width: 100%;
	height: 0.3rem;
	color: #fff;
	font-size: 0.2rem;
	padding: 0.1rpx 0.15rpx;
	box-sizing: border-box;
	border-bottom-right-radius: 0.12rem;
	border-bottom-left-radius: 0.12rem;
	background: linear-gradient(180.00deg, rgba(255, 255, 255, 0) 0, rgba(0, 0, 0, 0.2) 25%, rgba(0, 0, 0, 0.65) 100%);
}

.product-item .img-cover-1 {
	height: 0.2rem;
	line-height: 0.2rem;
	position: absolute;
	top: 0.1rem;
	left: 0.1rem;
	font-size: 0.2rem;
	color: #fff;
}

.product-item .img-cover-2 {
	height: 0.3rem;
	display: flex;
	align-items: center;
	text-align: right;
	padding-bottom: 0.05rem;
}

.product-item .icon-address {
	padding-right: 0.1rem;
	padding-left: 0.05rem;
}

.product-item .item-l-myshoppage {
	width: 2rem;
	height: 3rem;
}

.product-item .item-r-t {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.product-item .item-r-m {
	/* height: 1rem; */
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
}

.product-item .item-r-m .sell-count {
	width: 30%;
	font-size: 0.2rem;
	text-align: center;
	color: #999;
}

.product-item .item-r-t-l {
	font-size: 0.3rem;
}

.product-item .item-r-t-r {
	width: 0.6rem;
	height: 0.6rem;
	text-align: right;
}

.product-item .title {
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	display: -webkit-box;
}
.pitem-price-l-unit{
	font-weight: 600;
}
.product-item .title-text {
	font-weight: 600;
	font-size: 0.32rem;
	vertical-align: middle;
	padding-right: 0.1rem;
	line-height: 0.4rem;
}

.product-item .title-text2 {
	font-size: 0.24rem;
	vertical-align: middle;
	padding-right: 0.2rem;
	padding-left: 0.1rem;
	line-height: 0.4rem;
}

.product-item .icon-address {
	width: 0.15rem;
	height: 0.15rem;
}

.product-item .title-tag {
	font-size: 0.2rem;
	background-color: #D2B673;
	color: #fff;
	width: 0.8rem;
	height: 0.4rem;
	border-radius: 0.1rem;
	line-height: 0.4rem;
	text-align: center;
	display: inline-block;
	margin-top: -0.05rem;
	font-weight: bold
}

.product-item .item-r-subtitle {
	font-size: 0.26rem;
	color: #999;
	line-height: 0.4rem;
	height: 0.4rem;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	display: -webkit-box;
}

.product-item .item-r-subtitle-preorder {
	font-size: 0.26rem;
	color: #999;
	line-height: 0.4rem;
	height: auto;
	overflow: hidden;
	text-overflow: ellipsis;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	display: -webkit-box;
}

.item-r-b-date {
	font-weight: normal !important;
	font-size: 0.24rem !important;
	color: #333 !important;
}

.item-r-subtitle-activity {
	-webkit-line-clamp: 3 !important;
	height: 1.2rem !important;
}

.product-item .item-r-subtitle-skuname {
	font-size: 0.2rem;
	color: #999;
	line-height: 0.3rem;
	height: 0.3rem;
}

.product-item .item-r-comment {
	display: flex;
	flex-direction: row;
	align-items: center;
	height: 0.4rem;
	line-height: 0.4rem;
}

.product-item .score {
	font-weight: 600;
	font-size: 0.32rem;
}

.product-item .comment-count {
	font-size: 0.26rem;
	color: #999;
	padding-left: 0.2rem;
}

.product-item .item-r-tags {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	height: 0.4rem;
	overflow: hidden;
}

.product-item .tag-item {
	background-color: #FFF4D9;
	color: #FFAF35;
	font-size: 0.2rem;
	padding: 0rem 0.06rem;
	margin-right: 0.1rem;
	margin-bottom: 0.1rem;
	border-radius: 0.06rem;
	height: 0.3rem;
	display: flex;
	align-items: center;
	justify-content: center;
}

.product-item .item-r {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	flex: 1;
	padding-left: 0.2rem;
}

.product-item .item-r-price {
	width: 70%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	height: 0.5rem;
	line-height: 0.5rem;
}

.product-item .item-r-price .price {
	font-size: 0.36rem;
	color: #FF5A00;
	font-weight: 600;

}

.product-item .price-unit {
	color: #FF5A00;
	font-size: 0.24rem;
	margin-right: 0.05rem;
}

.product-item .price-qi {
	font-size: 0.24rem;
	color: #999;
}


.product-item .item-r-b {
	width: 100%;
	padding-top: 0.1rem;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}


.product-item .action-earn {
	background: linear-gradient(to right, #FF9C05, #FF6D30) !important;
}

.product-item .item-r-sold {
	width: 30%;
	position: relative;
}

.product-item .sell-order {
	max-width: 2rem;
	height: 0.5rem;
	background-color: #FF8324;
	color: #fff;
	font-size: 0.24rem;
	line-height: 0.5rem;
	text-align: center;
	background: linear-gradient(to right,
			#ffa60c,
			#FF8324);
	border-radius: 0.25rem;
}
.product-item .item-r-sold-offline .sell-order{
	background: none !important;
	background-color: #C2C6D0 !important;
}

.product-wrapper .bottom {
	text-align: center;
	font-size: 0.28rem;
	color: #999;
	padding: 0.4rem;
}

.no-order-pic {
	width: 30%;
	margin-bottom: 0.2rem;
}

.empty {
	width: 98vw;
	display: flex;
	flex-direction: column;
	align-items: center;
	background: #fff;
}

.empty img {
	width: 30%;
}

.empty .empty-txt {
	font-size: 0.28rem;
	color: #999;
	padding: 0.3rem;
}
.vocation-item-r-comment{
}
.vocation-item-r-comment span{
	font-size: 0.28rem;
	font-weight: normal;
	padding-left: 0.1rem;
}
.vocation-item-r-comment .score{
	line-height: 0.4rem;
	width: 2.5rem;
}
.vocation-item-r-comment .comment-count{
	line-height: 0.4rem;
	font-size: 0.28rem;
	flex:1;
	overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
	padding-left: 0rem;
}
.vocation-level{
	width: 0.7rem;
    height: 0.35rem;
    display: inline-block;
    position: relative;
    top: -0.01rem;
    vertical-align: bottom;
}
/* #endregion */

.product-item .title-tag-scenery {
	font-weight: bold;
	font-size: 0.2rem;
	background-color: #936BFF;
	color: #fff;
	width: 0.6rem;
	height: 0.4rem;
	border-radius: 0.1rem;
	line-height: 0.4rem;
	text-align: center;
	display: inline-block;
	margin-top: -0.05rem;
}
</style>



// WEBPACK FOOTER //
// src/page/cpsShop.vue